module.exports = __webpack_public_path__ + "assets/img/zyrw02.a13f9d31.png";